import { MessageCircleHeart } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './logo';

export default function Footer({
    isAuthenticated,
}: {
    isAuthenticated?: boolean;
}) {
    return (
        <footer className='bg-white mt-8 mb-[-24px]'>
            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'>
                <div className='flex flex-col md:flex-row justify-between items-center gap-4'>
                    <div className='flex items-center space-x-3 mb-4 md:mb-0'>
                        <div className='flex flex-col md:flex-row justify-around gap-2'>
                            <div className='flex items-center justify-center'>
                                <Logo size='45px' />
                            </div>

                            <div className='text-center md:text-left'>
                                <span className='text-lg font-semibold text-slate-800'>
                                    Advanced Sessions Management
                                </span>
                                <p className='text-xs text-slate-500'>
                                    Built with React, Express, PostgreSQL &
                                    Passport.js
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-center gap-2 text-center'>
                        <p className='flex justify-center items-center gap-1 text-balance text-center leading-loose text-slate-600 text-sm'>
                            Designed & implemented by
                            <Link
                                to={'//x.com/_isCoding'}
                                target='_blank'
                                rel='noreferrer'
                                className='font-semibold hover:underline underline-offset-4'>
                                Gabriel
                            </Link>
                            <Link
                                to={'//x.com/_isCoding'}
                                target='_blank'
                                rel='noreferrer'>
                                <MessageCircleHeart
                                    width={'20'}
                                    height={'20'}
                                />
                            </Link>
                        </p>
                    </div>
                    <div className='flex space-x-6 text-sm text-slate-600'>
                        <Link to={isAuthenticated ? '/settings' : '/'}>
                            <button className='hover:text-slate-900 transition-colors'>
                                {isAuthenticated ? 'Settings' : 'Home'}
                            </button>
                        </Link>
                        <span>•</span>
                        <Link to={isAuthenticated ? '/mfa' : '/login'}>
                            <button className='hover:text-slate-900 transition-colors'>
                                {isAuthenticated ? 'MFA' : 'Login'}
                            </button>
                        </Link>
                        <span>•</span>
                        <Link to={isAuthenticated ? '/account' : '#'}>
                            <button className='hover:text-slate-900 transition-colors'>
                                {isAuthenticated ? 'Account' : 'Support'}
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
